var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { desktop: _vm.renderDesktopMode }, attrs: { id: "app" } },
    [
      _vm.appConfigIsLoaded ? _c("maNavBar") : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.stateLoader || !_vm.appConfigIsLoaded
            ? _c("ma-loader")
            : _vm._e(),
        ],
        1
      ),
      _c("ma-notifications"),
      _c(
        "div",
        {
          staticClass: "app-wrapper",
          class: { bpce: _vm.getFlowCompany === "BPCE" },
        },
        [
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_vm.appConfigIsLoaded ? _c("router-view") : _vm._e()],
            1
          ),
        ],
        1
      ),
      (_vm.getFlowCompany && _vm.getFlowCompany !== "BPCE") || !_vm.isBPCE
        ? _c("ma-button-phone")
        : _vm._e(),
      _c("div", { attrs: { id: "background" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }